var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addData,
            rules: _vm.rules,
            "label-width": "20px",
            "label-position": "right",
            size: "mini"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "1050px", height: "700px" },
              attrs: { label: "", prop: "longContent" }
            },
            [
              _c(
                "div",
                [
                  _c("Tinymce", {
                    attrs: { height: 600, imagePath: "robot/introduction" },
                    model: {
                      value: _vm.addData.longContent,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "longContent", $$v)
                      },
                      expression: "addData.longContent"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { size: "large" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "160px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v("发布")]
              ),
              _vm._v(" "),
              _vm.searchData.insId !== ""
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", icon: "el-icon-back" },
                      on: {
                        click: function() {
                          return this$1.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v("返回")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }